import type { VoiceRecorderState } from '../VoiceRecorder/VoiceRecorder';
import { VOICE_ICON, VOICE_LABEL } from '../VoiceRecorder/voiceStates';
import styles from './VoiceStatusPill.module.css';

export interface VoiceStatusPillProps {
  state: VoiceRecorderState;
  live?: boolean;
  className?: string;
  expanded?: boolean;
  onToggleDetails?: () => void;
  detailsId?: string;
}

/** Pastille d'état vocal : icône + texte dans la couleur de l'état, sans animation (VREC1 §3.6). */
export function VoiceStatusPill({
  state,
  live = true,
  className,
  expanded = false,
  onToggleDetails,
  detailsId,
}: VoiceStatusPillProps) {
  const label = VOICE_LABEL[state];
  const pill = (
    <span
      data-state={state}
      title={label}
      className={[styles.pill, onToggleDetails ? '' : styles[state], className].filter(Boolean).join(' ')}
      {...(live ? { role: 'status', 'aria-atomic': 'true' } : {})}
    >
      <i className={`bi ${VOICE_ICON[state]} ${styles.icon}`} aria-hidden="true" />
      <span className={styles.text}>{label}</span>
    </span>
  );
  if (!onToggleDetails) return pill;
  return (
    <div className={`${styles.wrap} ${styles[state]}`}>
      {pill}
      <button
        type="button"
        className={styles.chevron}
        aria-expanded={expanded}
        aria-controls={detailsId}
        aria-label={expanded ? 'Masquer le détail' : 'Afficher le détail'}
        onClick={onToggleDetails}
      >
        <i className={`bi ${expanded ? 'bi-chevron-up' : 'bi-chevron-down'}`} aria-hidden="true" />
      </button>
    </div>
  );
}
